import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles(() => ({
  timeText: {
    color: '#333',
    fontSize: '30px',
    fontWeight: 'bold',
  },
  dateText: {
    color: '#a9a9a9',
    fontSize: '14px',
  },
  timeZoneContainer: {
    display: 'flex',
    alignItems: 'center',
    gap: '4px',
  },
  settingsIcon: {
    color: '#5469d4',
    fontSize: '15px',
  },
}));
